import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const cities = [
  { name: "Delhi", left: "30.9%", top: "30.3%", label: "right" },
  { name: "Ahmedabad", left: "15%", top: "49.1%", label: "left" },
  { name: "Surat", left: "15.9%", top: "55.1%", label: "left" },
  { name: "Nagpur", left: "37.3%", top: "55.2%", label: "right" },
  { name: "Nashik", left: "19.2%", top: "58.9%", label: "right" },
  { name: "Mumbai", left: "16%", top: "61.8%", label: "left" },
  { name: "Pune", left: "19.4%", top: "63.6%", label: "bottom" },
  { name: "Hyderabad", left: "35.2%", top: "67.2%", label: "right" },
  { name: "Chennai", left: "41.4%", top: "80.6%", label: "right" },
];

const labelClass = {
  right: "left-4 top-1/2 -translate-y-1/2",
  left: "right-4 top-1/2 -translate-y-1/2",
  bottom: "top-4 left-1/2 -translate-x-1/2",
};

export const IndiaMap = () => (
  <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-10 bg-[#FAFAF8]" data-testid="india-map-section">
    <div className="max-w-7xl mx-auto bg-[#0E0E0E] rounded-3xl overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
        <div className="p-8 sm:p-12 lg:p-16">
          <Reveal>
            <span className="font-heading text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-[#D8B98A]">Pan-India Presence</span>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1] text-white">
              Courses conducted <em className="font-bold text-[#D8B98A]">all over India</em>.
            </h2>
            <p className="mt-6 max-w-md text-lg text-white/75 leading-relaxed">
              From Mumbai to Delhi, Chennai to Ahmedabad, Dr. Kshama's hands-on programs
              travel across the country, bringing world-class aesthetic dentistry training to your city.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-9 flex flex-wrap gap-2.5" data-testid="india-cities-list">
            {cities.map((c) => (
              <span key={c.name} className="inline-flex items-center gap-1.5 font-heading text-xs font-bold tracking-[0.08em] uppercase px-4 py-2 rounded-full border border-[#D8B98A]/40 text-[#EBD9BC]">
                <MapPin size={12} className="text-[#D8B98A]" /> {c.name}
              </span>
            ))}
          </Reveal>
        </div>

        <Reveal delay={0.2} className="relative p-8 sm:p-12 lg:py-16 lg:pr-16">
          <div className="mx-auto max-w-[440px] pl-9 pr-1 sm:px-0">
            <div className="relative" data-testid="india-map">
              <img src="/images/india-map.svg" alt="Map of India" className="w-full h-auto opacity-95" />
              {cities.map((c) => (
                <div key={c.name} className="absolute" style={{ left: c.left, top: c.top }}>
                  <span className="map-pin-ring" />
                  <span className="map-pin-dot" />
                  <span className={`absolute whitespace-nowrap font-heading text-[9px] sm:text-[10px] font-bold tracking-[0.1em] uppercase text-[#EBD9BC] ${labelClass[c.label]}`}>
                    {c.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
